import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent {
  @Input() rating: number = 0;
  @Input() size: 'medium' | 'large' = 'medium';
  @Input() filledColor: string = '#f6b800';

  get starStyles() {
    return {
      '--rating': this.rating.toString(),
      '--star-filled-color': this.filledColor,
    };
  }
}
